module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#pdf",
      toString: function () {
        return this.url;
      }
    }